export default "__VITE_ASSET__3b3cbc3f__"